import React from 'react';

import api from '../../api.js';

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export default function withLogos(WrappedComponent) {
  class WithLogos extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: true,
        logos: [],
      };
    }

    componentDidMount = async () => {
      const logos = (await api.offers.availableLogos()).data.map((logo) => ({
        id: logo?.picture?.id ?? 0,
        label: logo?.filename,
        imageUrl: logo?.picture?.image ?? ''
      }));
      this.setState({
        logos,
        loading: false,
      });
    }

    render() {
      return <WrappedComponent
        loading={this.props.loading || this.state.loading}
        logos={this.state.logos}
        {...this.props}
      />
    }
  }

  WithLogos.displayName = `WithLogos(${getDisplayName(WrappedComponent)})`;

  return WithLogos;
}